mutation UploadRecording(
  $file: Upload!
  $sentence: ID!
  $segments: [Int!]!
  $manualSegments: [Int!]
  $nwords: Int!
  $segmentedSentence: ID
  $autoSegment: Boolean!
  $replacesSegment: Int
  $sentenceRecording: ID
  $optionalFilename: String
  $pronunciation: ID!
  $aliyah: ID
  $haftarah: ID
  $sentenceGroup: ID
  $torahMelodyStyle: ID
  $haftarahMelodyStyle: ID
  $sentenceGroupMelodyStyle: ID
  $tags: [ID!]!
) {
  uploadRecording(
    file: $file
    sentence: $sentence
    segments: $segments
    manualSegments: $manualSegments
    nwords: $nwords
    segmentedSentence: $segmentedSentence
    autoSegment: $autoSegment
    replacesSegment: $replacesSegment
    sentenceRecording: $sentenceRecording
    optionalFilename: $optionalFilename
    pronunciation: $pronunciation
    aliyah: $aliyah
    haftarah: $haftarah
    sentenceGroup: $sentenceGroup
    torahMelodyStyle: $torahMelodyStyle
    haftarahMelodyStyle: $haftarahMelodyStyle
    sentenceGroupMelodyStyle: $sentenceGroupMelodyStyle
    tags: $tags
  ) {
    ok
    errors
    id
  }
}
